import { getUrlParam, getshareTitle } from "./util";
function isIos() {
  var iOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
  if (iOS) {
    return true;
  }
  return false;
}

const toCallApp = function(jsonData) {
  console.log("当前分享的json", jsonData);
  if (isIos()) {
    window.webkit.messageHandlers.app.postMessage(jsonData);
  } else {
    console.log(app);
    app.webcall(jsonData);
  }
};
function hllAppShare(payload) {
  shareH5();
  // toShareMiprogramOld(payload)
}

//保存图片
export const toSaveImg = function(url) {
  //alert(11);
  var jsonData = '{"action":"saveImg","data":""}';
  var path =
    url ||
    "https://charter.huolala.cn/h5/cdn/img/202003-backups/hint-bg-driver.png";
  var ext = "jpg";
  if (path.indexOf(".png") >= 0) {
    ext = "png";
  }
  // alert(ext);
  getUrlBase64(path, ext, 0, 0, function(base64) {
    console.log(base64); //base64编码值
    //alert(base64);
    jsonData = '{"action":"saveImg","data":"' + base64 + '"}';
    toCallApp(jsonData);
  });
};
function getImageSizeInBytes(imgURL) {
  var request = new XMLHttpRequest();
  request.open("HEAD", imgURL, false);
  request.send(null);
  var headerText = request.getAllResponseHeaders();
  var re = /Content\-Length\s*:\s*(\d+)/i;
  re.exec(headerText);
  return parseInt(RegExp.$1);
}
function getUrlBase64(url, ext, _w, _h, callback) {
  var canvas = document.createElement("canvas"); // 创建canvas DOM元素
  var ctx = canvas.getContext("2d");
  var img = new Image();
  img.crossOrigin = "*";
  img.src = url;
  // alert(1);
  var size = getImageSizeInBytes(url);
  // var size_image = size / 1000;
  // alert("size_image", size_image);
  // alert(2);
  img.onload = function() {
    var w = _w == 0 ? img.width : _w;
    var h = _h == 0 ? img.height : _h;
    //alert("图片大小:"+h+" x "+w+" sucess");
    canvas.height = h; //指定画板的高度,自定义
    canvas.width = w; //指定画板的宽度，自定义
    console.log("图片大小:" + h + " x " + w);
    ctx.drawImage(img, 0, 0, w, h); //参数可自定义
    var dataURL = canvas.toDataURL("image/" + ext);
    callback.call(this, dataURL); //回掉函数获取Base64编码
    canvas = null;
  };
}
// 分享H5
export const shareH5 = function() {
  let shareTitle = getshareTitle();
  let inviteId = getUrlParam("inviteId");
  let ADTAG = getUrlParam("ADTAG");
  // let ref = getUrlParam("ref");
  let ref = "share34";
  let isDriver = getUrlParam("portType") === "hlldriver" || false;
  let pathname = window.location.pathname;
  if (pathname.includes("prize.html")) {
    pathname = window.location.pathname.split("prize.html")[0] + "index.html";
  }
  let url =
    window.location.origin + pathname + "?ref=" + ref + "&ADTAG=" + ADTAG;
  // let url = window.location.origin + window.location.pathname + '?inviteId=' + inviteId + '&ref=' + ref + '&ADTAG=' + ADTAG
  // let url = 'https://charter.huolala.cn/h5/march-activity/index.html' + '?inviteId=' + inviteId + '&ref=' + ref + '&ADTAG=' + ADTAG

  var jsonData =
    '{"action":"share","to":"wechat1,wechatn","title":"' +
    shareTitle.title +
    '","content":"' +
    shareTitle.content +
    '","icon_url":"https://charter.huolala.cn/h5/march-activity/img/share.png","link_url":"' +
    url +
    '"}';
  toCallApp(jsonData);
  // 司机端
  if (isDriver) {
    jsonData =
      '{"action":"shareNew","to":"wechat1,wechatn","title":"' +
      shareTitle.title +
      '","content":"' +
      shareTitle.content +
      '","icon_url":"https://charter.huolala.cn/h5/march-activity/img/share.png","link_url":"' +
      url +
      '"}';
    toCallApp(jsonData);
  }
};
//分享小程序
export const toShareMiprogramOld = function(payload) {
  let shareTitle = getshareTitle();
  let path = "page/homepage/pages/H5/index" + payload;
  console.log("分享出去的小程序url", path);
  let inviteId = getUrlParam("inviteId");
  let ref = getUrlParam("ref");
  let url =
    window.location.origin +
    window.location.pathname +
    "?inviteId=" +
    inviteId +
    "&ref=" +
    ref;
  var jsonData =
    '{"action":"shareMiniPrograme","to":"wechat1,wechatn","title":"' +
    shareTitle.title +
    '","description":"' +
    shareTitle.content +
    '",' +
    '"icon_url":"https://charter.huolala.cn/h5/cdn/img/november-share-big.png",' +
    '"userName":"gh_3d4bd50ac5ae","path":"' +
    path +
    '","webpageUrl":"' +
    url +
    '","miniprogram_type":""}';
  // 拉拉 gh_463cd1c3ab73
  // 货拉拉 gh_3d4bd50ac5ae
  toCallApp(jsonData);
};
// 留资改造分享小程序
//分享小程序
export const toShareMiprogramNew = function(payload) {
  const jsonData = JSON.stringify({
    action: "shareNew",
    type: "1", // 分享类型：0 普通链接、1 小程序、2 图片
    to: "wechat1,wechatn", // 分享目标，这里只能写一个目标。目标枚举:wechat1-发送给微信朋友,wechatn-发送给微信朋友圈
    title: payload.appletsText, // 分享标题
    miniprogram_path: payload.shareUrl, // 小程序路径
    miniprogram_webpage_url: payload.shareUrl, // 兼容旧版
    miniprogram_id: "gh_3d4bd50ac5ae", // 小程序id
    miniprogram_type: "2", // 小程序版本
    icon_url: payload.appletsImg // 图标地址
  });
  toCallApp(jsonData);
  // const { appletsImg, appletsText, shareUrl } = payload;
  // var jsonData =
  //   '{"action":"shareNew","type":"0,1","to":"wechat1,wechatn","miniprogram_id":"gh_3d4bd50ac5ae","miniprogram_type":"0","miniprogram_path":"' +
  //   shareUrl +
  //   '","title":"' +
  //   appletsText +
  //   '","icon_url":"' +
  //   appletsImg +
  //   '","link_url":"' +
  //   appletsImg +
  //   '"}';
  // toCallApp(jsonData);
  // let shareTitle = getshareTitle();
  // let path = "page/homepage/pages/H5/index" + payload;
  // console.log("分享出去的小程序url", path);
  // let inviteId = getUrlParam("inviteId");
  // let ref = getUrlParam("ref");
  // let url =
  //   window.location.origin +
  //   window.location.pathname +
  //   "?inviteId=" +
  //   inviteId +
  //   "&ref=" +
  //   ref;
  // var jsonData =
  //   '{"action":"shareMiniPrograme","to":"wechat1,wechatn","title":"' +
  //   shareTitle.title +
  //   '","description":"' +
  //   shareTitle.content +
  //   '",' +
  //   '"icon_url":"https://charter.huolala.cn/h5/cdn/img/november-share-big.png",' +
  //   '"userName":"gh_3d4bd50ac5ae","path":"' +
  //   path +
  //   '","webpageUrl":"' +
  //   url +
  //   '","miniprogram_type":""}';
  // // 拉拉 gh_463cd1c3ab73
  // // 货拉拉 gh_3d4bd50ac5ae
  // toCallApp(jsonData);
};
export const openWXMiniprogram = function(url, imgUrl, title) {
  console.log("1111", url, imgUrl, title);
  let ref = getUrlParam("ref");
  let portType = getUrlParam("portType");
  if (portType === "hlluser") {
    // 用户
    let toUrl = url || "page/my/pages/signIn/index";
    let path = `${toUrl}`;
    var jsonData =
      '{"action":"openWXMiniprogram","to":"wechat1, wechatn","title":"' +
      title +
      '","content":"货拉拉购车",' +
      '"icon_url":"' +
      imgUrl +
      '","link_url":"",' +
      '"appName":"gh_3d4bd50ac5ae","path":"' +
      path +
      '","miniprogram_webpage_url":"","miniprogram_type":""}';
    toCallApp(jsonData);
  }
  // 司机
  if (portType === "hlldriver") {
    let toUrl = url || "page/my/pages/signIn/index";
    let path = `${toUrl}`;
    var jsonData =
      '{"action":"openWxMini","type":"0","proId":"gh_3d4bd50ac5ae","path":"' +
      path +
      '"}';
    toCallApp(jsonData);
  }
};
export const getAppPosition = function() {
  var json = '{"action":"position", "callback": "hllAppPositionCallBack"}';
  toCallApp(json);
};
export const AppCloseWebView = function() {
  var json = '{"action":"closeWebView"}';
  toCallApp(json);
};
